import { Component, Input, OnInit } from '@angular/core';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { AuthMyfileService, UserContextType } from 'src/app/core/services/auth.myfile.service';
import { GlobalComponent } from 'src/app/global-component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  // set the currenr year
  year: number = new Date().getFullYear();
  userContext: UserContextType = this.authService.currentUserContextValue;
  version?: string;
  flag?: boolean; 
  
  userLoginPath = GlobalComponent.authRedirectUrls.userSignIn;
  clientLoginPath = GlobalComponent.authRedirectUrls.clientSignIn;

  @Input() loginType?:LoginType = undefined; 

  constructor(  private authService: AuthMyfileService) { }

  ngOnInit(): void {
    if(this.userContext){
      this.version = environment.appVersion;
      this.flag = environment.production;
    }else{
      this.version = undefined;
      this.flag = undefined;
    }
  }

  statusTextStyle(status: boolean|undefined) {
    switch (status) {
      case true:
        return { 'color': '#13c56b', 'background-color': '#13c56b1a', 'padding-top': '3px', 'padding-bottom': '2px', "font-size": ".75em", "font-weight": "500", "padding-right": "0.65em", "padding-left": "0.65em" }
      case false:
        return { 'color': '#ed5e5e', 'background-color': '#ed5e5e1a', 'padding-top': '3px', 'padding-bottom': '2px', "font-size": ".75em", "font-weight": "500", "padding-right": "0.65em", "padding-left": "0.65em" }
      default:
        return null
    }
  }

  get loginTypeEnum(): typeof LoginType {
    return LoginType; 
  }
  
}
